import { render } from "./Search.vue?vue&type=template&id=5d2f52bb"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2f52bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2f52bb', __exports__)) {
    api.reload('5d2f52bb', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=5d2f52bb", () => {
    api.rerender('5d2f52bb', render)
  })

}


export default __exports__